import React from 'react';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';

import { ActionsContainer, TemplateCardContainer, TextContainer } from './TemplateCard.styled';

const SkeletonCard = () => (
  <TemplateCardContainer>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <TextContainer>
        <Skeleton
          role="progressbar"
          variant="rect"
          width={250}
          height={18}
          className="margin-right-bottom-1"
        />
        <Skeleton
          role="progressbar"
          variant="rect"
          width={400}
          height={16}
          className="margin-right-bottom-1"
        />
        <Skeleton
          role="progressbar"
          variant="rect"
          width={400}
          height={16}
          className="margin-right-bottom-1"
        />
      </TextContainer>
      <ActionsContainer>
        <Skeleton role="progressbar" variant="circle" width={32} height={32} />
        <Skeleton role="progressbar" variant="circle" width={32} height={32} />
      </ActionsContainer>
    </Box>
  </TemplateCardContainer>
);

export const TemplateCardSkeleton = () => {
  return (
    <>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </>
  );
};
